<div class="contacts-block">
  <h2 class="common-section-title contacts-block__title theme-contacts__title">{{ lg.contactsBlock.heading }}</h2>
  <p class="contacts-block__descr theme-contacts__descr">{{ lg.contactsBlock.getDescription(beatmakerName) }}</p>
  <p class="contacts-block__required-text theme-contacts__requiredField">
    {{ lg.contactsBlock.requiredFieldDescription }}
  </p>
  <div class="contacts-block__social-icons">
    <bmcore-social-icons
      [appType]="appType"
      [socialContacts]="socialContacts"
      [BMTVContacts]="BMTVContacts"
    ></bmcore-social-icons>
  </div>
  <bmcore-contacts-form
    class="contacts-block__form"
    [beatmakerId]="beatmakerId"
    [emailSecret]="emailSecret"
    [routerPath]="''"
    [sourceType]="sourceType"
  >
  </bmcore-contacts-form>
</div>
